import React from 'react';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import styled from '@emotion/styled';
import { ADMIN_PERMISSION_URL } from '../../utils';
import { StyledFooter } from '../../order-confirmation.styles';

const StyledSuccessContent = styled.div({
  marginTop: '30px',
});

const StyledContentRow = styled.div({
  marginBottom: '15px',
});

export const NewSiteSuccessContent = ({
  onGetStarted,
  isDesignIteration1Enabled,
}: {
  onGetStarted: () => void;
  isDesignIteration1Enabled?: boolean;
}) => {
  return (
    <StyledSuccessContent>
      <StyledContentRow>
        You can get started by setting up a cloud site. We’ve also sent a notification to your customer with a link to
        set up a cloud site and get started.
      </StyledContentRow>
      <StyledContentRow>
        <Button appearance="primary" onClick={onGetStarted} shouldFitContainer testId="site-provisioning-btn">
          Get started
        </Button>
      </StyledContentRow>
      <StyledFooter isDesignIteration1Enabled={isDesignIteration1Enabled}>
        Whoever sets up the site will automatically get admin permissions as an org and a site admin. They can also give
        admin roles to others - see{' '}
        <a href={ADMIN_PERMISSION_URL} target="_blank">
          how to give users admin permissions.
        </a>
      </StyledFooter>
    </StyledSuccessContent>
  );
};
